export enum AdminQuestionnaireTableColumnDataIndex {
  Name = "name",
  Link = "link",
  Options = "options",
}
